// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__32Wr8","header":"ClearentDisclaimer_header__MHeXs","inner":"ClearentDisclaimer_inner__2kA4Y"};